import { Component, OnInit } from '@angular/core';
import { WompiReportsService, UploadedReportsResponseDTO, WompiReportSummaryDTO, PlinkReportSummaryDTO } from '../../../services/wompi-reports.service';
import { ToastService } from '../../../services/toast.service';
import { LoadingService } from '../../../services/loading.service';

@Component({
  selector: 'app-uploaded-reports',
  templateUrl: './uploaded-reports.component.html',
  styleUrls: ['./uploaded-reports.component.scss']
})
export class UploadedReportsComponent implements OnInit {
  // Data
  response: UploadedReportsResponseDTO | null = null;
  wompiReports: WompiReportSummaryDTO[] = [];
  plinkReports: PlinkReportSummaryDTO[] = [];

  // Filters
  dateFrom: string = '';
  dateTo: string = '';
  conciliatedFilter: string = 'all'; // 'all', 'true', 'false'
  linkedFilter: string = 'all'; // 'all', 'true', 'false'

  // Pagination
  currentPage: number = 1;
  pageSize: number = 25;

  // UI State
  loading: boolean = false;
  activeTab: 'wompi' | 'plink' = 'wompi';

  constructor(
    private wompiReportsService: WompiReportsService,
    private toastService: ToastService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    // Set default date range to last 30 days
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    this.dateTo = this.formatDateForInput(today);
    this.dateFrom = this.formatDateForInput(thirtyDaysAgo);

    this.loadReports();
  }

  loadReports(): void {
    this.loading = true;
    this.loadingService.show();

    const from = this.dateFrom ? new Date(this.dateFrom) : undefined;
    const to = this.dateTo ? new Date(this.dateTo) : undefined;
    const conciliated = this.conciliatedFilter === 'all' ? undefined : this.conciliatedFilter === 'true';
    const linked = this.linkedFilter === 'all' ? undefined : this.linkedFilter === 'true';

    this.wompiReportsService.getUploadedReports(from, to, conciliated, linked, this.currentPage, this.pageSize)
      .subscribe({
        next: (response) => {
          this.response = response;
          this.wompiReports = response.wompiReports;
          this.plinkReports = response.plinkReports;
          this.loading = false;
          this.loadingService.hide();
        },
        error: (error) => {
          console.error('Error loading reports:', error);
          this.toastService.showToast('error', 'Error al cargar los reportes');
          this.loading = false;
          this.loadingService.hide();
        }
      });
  }

  get currentTotalRecords(): number {
    if (!this.response) return 0;
    return this.activeTab === 'wompi' ? this.response.totalWompiReports : this.response.totalPlinkReports;
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.loadReports();
  }

  clearFilters(): void {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    this.dateTo = this.formatDateForInput(today);
    this.dateFrom = this.formatDateForInput(thirtyDaysAgo);
    this.conciliatedFilter = 'all';
    this.linkedFilter = 'all';
    this.currentPage = 1;
    this.loadReports();
  }

  setTab(tab: 'wompi' | 'plink'): void {
    this.activeTab = tab;
    // Optional: Reset page if needed, but keeping current behavior of shared pagination context
    // this.currentPage = 1; 
    // this.loadReports();
  }

  onPageChange(event: any) {
    this.currentPage = event.page + 1; // PrimeNG is 0-indexed
    this.pageSize = event.rows;
    this.loadReports();
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CO', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  private formatDateForInput(date: Date): string {
    return date.toISOString().split('T')[0];
  }
}

